export function buildSearchEndpoint(templateUrl, { country, cursor, term }) {
  const path = templateUrl?.replace('*country*', encodeURIComponent(country))

  const params = new URLSearchParams()
  if (term) params.set('term', term)
  if (cursor) params.set('cursor', cursor)

  const query = params.toString()
  return query ? `${path}?${query}` : path
}
